import { classNames } from "../../helpers/classNames";
import Image from "../../components/elements/Image";

const Indentification = ({
  image,
  initial,
  className,
  divStyle,
  initialClass,
  initialStyle,
  defaultClass,
  defaultStyle,
  fill = true,
  alt,
  size = "md",
  style,
  type = "circle",
}) => {
  const imageSize = {
    xs: "w-6 h-6",
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
    "2xl": "w-20 h-20",
    "3xl": "w-24 h-24",
    max: "w-full h-full",
  };

  const src = image;
  let isVideo = false;
  if (image && typeof image === "string") {
    const ext = src?.split(".")?.pop()?.toLowerCase();
    isVideo = ["mp4", "webm"].includes(ext);
  }

  return (
    <div
      className={classNames(
        "overflow-hidden bg-primary/10 flex items-center justify-center flex-shrink-0",
        imageSize[size],
        initial ? "text-sm" : "",
        type === "circle"
          ? "rounded-full"
          : type === "square"
          ? "rounded-lg"
          : "",
        className
      )}
      style={divStyle}
    >
      {image ? (
        isVideo ? (
          <video
            className={classNames(
              "w-full h-full",
              fill ? "object-cover" : "object-contain"
            )}
            src={image}
            alt={alt || initial || image}
            controls
          />
        ) : (
          <Image
            src={image}
            alt={alt || initial || image}
            classes={classNames(
              "w-full h-full",
              fill ? "object-cover" : "object-contain"
            )}
          />
        )
      ) : initial ? (
        <div
          className={classNames(
            `w-full h-full flex items-center justify-center font-semibold uppercase text-base ${
              initialStyle?.background ? "" : "bg-danger-light"
            } text-primary !leading-none`,
            initialClass
          )}
          style={initialStyle}
        >
          <span className="-mt-[2px]">{initial}</span>
        </div>
      ) : (
        <div
          className={classNames(
            "w-full h-full flex items-center justify-center bg-primary text-opplio-graySky",
            defaultClass
          )}
          style={defaultStyle}
        >
          <i className="fa-light fa-fw fa-user text-[90%] scale-[1.8]"></i>
        </div>
      )}
    </div>
  );
};

export default Indentification;
